import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-request-type-icon',
  templateUrl: './request-type-icon.component.html'
})
export class RequestTypeIconComponent {
  @Input() isAdd: boolean;
  @Input() label: string;
}
